import { InjectionToken } from '@angular/core';
import { Converter } from '@spartacus/core';
import { ExtendedTicketDetails } from './TicketDetails';
import { ExtendedTicketStarter } from './TicketStarter';

export const GONVARRI_CUSTOMER_TICKETING_DETAILS_NORMALIZER: InjectionToken<Converter<any, ExtendedTicketDetails>> = new InjectionToken<Converter<any, ExtendedTicketDetails>>('GONVARRI_CUSTOMER_TICKETING_DETAILS_NORMALIZER');
export const GONVARRI_CUSTOMER_TICKETING_CREATE_NORMALIZER: InjectionToken<Converter<any, ExtendedTicketStarter>> = new InjectionToken<Converter<any, ExtendedTicketStarter>>('GONVARRI_CUSTOMER_TICKETING_CREATE_NORMALIZER');
